import { render, staticRenderFns } from "./SettingEditDialog.vue?vue&type=template&id=2615c162&scoped=true&"
import script from "./SettingEditDialog.vue?vue&type=script&lang=js&"
export * from "./SettingEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615c162",
  null
  
)

export default component.exports